import { render, staticRenderFns } from "./TermsOfServicePage.vue?vue&type=template&id=2f7c9bb8&"
import script from "./TermsOfServicePage.vue?vue&type=script&lang=ts&"
export * from "./TermsOfServicePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/_locales/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Fadministration%2FTermsOfServicePage.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/components/shared/_locales/TermsOfServiceModal.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Fadministration%2FTermsOfServicePage.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports